import { useState } from 'react';
import SourcesAPI from '../../SourcesAPI';
import { NotificationService } from '../../../../Components/Notifications';
import {
  getCompanyMarketingSourcesOptions,
  getCompanySourcesMap,
} from '../utils';
import { COMPANY_SOURCE_MODE, ERROR_MESSAGES } from '../constants';
import { SAVED_NOTIFICATION } from '../../../../constants';

export const useManageCompanySource = ({
  companyMarketingSources,
  reloadCompanySources,
}) => {
  const [errorMessage, setErrorMessage] = useState();
  const [modalMode, setModalMode] = useState(null);

  const getAllMarketingSources = async () => {
    try {
      const { marketing_sources } = await SourcesAPI.getAllMarketingSources();
      const sourceOptions = marketing_sources.map((source) => ({
        id: source.id,
        label: source.name,
      }));

      return sourceOptions;
    } catch {
      setErrorMessage(ERROR_MESSAGES.ALL_SOURCES);
    }
  };

  const getAllCompanyMarketingSourcesOptions = () => {
    const companyMarketingSourceOptions = getCompanyMarketingSourcesOptions(
      companyMarketingSources
    );

    return companyMarketingSourceOptions;
  };

  const addCompanyMarketingSource = async (source) => {
    try {
      await SourcesAPI.addCompanyMarketingSource(source.id);
      NotificationService.notify(SAVED_NOTIFICATION);
      reloadCompanySources();
      handleModalMode(null)();
    } catch {
      setErrorMessage(ERROR_MESSAGES.ADD_SOURCE);
    }
  };

  const removeCompanyMarketingSource = async (source) => {
    try {
      await SourcesAPI.removeCompanyMarketingSource(source.id);
      NotificationService.notify(SAVED_NOTIFICATION);
      reloadCompanySources();
      handleModalMode(null)();
    } catch (e) {
      setErrorMessage(e.message);
    }
  };

  const getSourcesDisabledToAdd = (option) => {
    const sourceMap = getCompanySourcesMap(companyMarketingSources);
    return Boolean(sourceMap[option.id]);
  };

  const getSourcesDisabledToRemove = (option) => {
    return Boolean(option.leasingTeamEnabledCount);
  };

  const handleSubmit = (source) => {
    modalMode === COMPANY_SOURCE_MODE.ADD
      ? addCompanyMarketingSource(source)
      : removeCompanyMarketingSource(source);
  };

  const sources =
    modalMode === COMPANY_SOURCE_MODE.ADD
      ? getAllMarketingSources()
      : getAllCompanyMarketingSourcesOptions();

  const getOptionsDisabled = (option) => {
    return modalMode === COMPANY_SOURCE_MODE.ADD
      ? getSourcesDisabledToAdd(option)
      : getSourcesDisabledToRemove(option);
  };

  const handleModalMode = (mode) => () => {
    setModalMode(mode);
  };

  return {
    errorMessage,
    getOptionsDisabled,
    handleModalMode,
    handleSubmit,
    modalMode,
    sources,
    setErrorMessage,
  };
};
